<ftr-page-layout
  class="request-cart"
  name="cart"
  [pageStyle]="pageStyle"
  displayMode="FILL"
  [bodyTemplate]="bodyTemplate"
  [entity]="viewModel$"
  errorMessage="Failed to load cart. Please try again or contact support@fortherecord.com for support."
  (onRetry)="refresh.next()"
  [emptyBodyTemplate]="emptyCartTemplate"
  [staticHeaderTemplate]="headerTemplate"
>
  <ng-template #headerTemplate>
    <h1>Cart</h1>
  </ng-template>
  <ng-template #bodyTemplate let-vm [ftrTypedContext]="viewModel$">
    @if (removedCartItems) {
      <ftr-alert class="request-cart__alert" [type]="alertTypes.Info">
        Your cart has been updated based on available timeframes. Please review the time frames below before proceeding
        with the request.
      </ftr-alert>
    }
    @if (cartIsPopulated()) {
      @if (courtSystem(); as courtSystem) {
        <p class="request-cart__summary">
          Time frames can be edited and deleted in order to specify the content you would like to request from
          {{ courtSystem.name }}.
        </p>

        <div class="request-cart__groups">
          @for (group of cartGroups(); track group.key) {
            <div class="request-cart__group">
              <ftr-request-cart-group-metadata [courtSystemId]="courtSystem.id" [group]="group" />
              @for (item of group.items; track item.id) {
                @if (itemIdBeingEdited() === item.id) {
                  <ftr-cart-item-form
                    [sessionStartTime]="item.startTime"
                    [sessionEndTime]="item.endTime"
                    [requestedTimes]="item.requestedTimes"
                    [courtTimeZoneId]="getCourtTimeZoneId(vm!.configuration.timeZoneId)"
                    (cancelClicked)="closeEditItemForm()"
                    (formSubmitted)="onItemTimeframesSaved(item.id, $event)"
                  />
                } @else {
                  <div class="request-cart__item">
                    <ftr-cart-times-display [requestedTimes]="item.requestedTimes" [maxVisible]="2" />
                    <div class="request-cart__item-toolbar">
                      <button ftrIconButton icon="Edit" size="small" (click)="openEditItemForm(item.id)">Edit</button>
                      <button ftrIconButton icon="Delete" size="small" (click)="removeItems([item.id])">Remove</button>
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>

        @if (checkoutPath()) {
          <div class="request-cart__buttons">
            <a ftrButton color="primary" [routerLink]="checkoutPath()">Request</a>
            <button ftrButton color="secondary" (click)="location.back()">Continue browsing</button>
          </div>
        }
      }
    } @else {
      <ng-container *ngTemplateOutlet="emptyCartTemplate" />
    }
  </ng-template>
  <ng-template #emptyCartTemplate>
    <div class="request-cart__empty-state">
      <ftr-empty-state [messageTemplate]="emptyTemplate" [illustration]="emptyIllustration" />
      <ng-template #emptyTemplate>
        <span>There are no items in your cart.</span>
        <p>
          Request <a [routerLink]="recordingsRequestPath()">recordings</a> or
          <a [routerLink]="transcriptRequestPath()">transcripts</a> to add items to your cart.
        </p>
      </ng-template>
    </div>
  </ng-template>
</ftr-page-layout>
